import loadScript from './utils/load-script'
import config from './config'

const getApi = (win = window) => {
  if (win.__KlarnaNativeHook) {
    return Promise.resolve(win.__KlarnaNativeHook)
  }
  return loadScript(config.sdkBridgeScriptURL).then(() => {
    return win.__KlarnaNativeHook
  })
}

export default getApi
